
<template>
  <v-app>
    <!-- 1°first ROW -->
    <div class="row">
      <div class="col-md-12">
        <!-- 1°first Card -->
        <v-card outlined tile elevation="1">
          <v-card-title >
            Bodegas
            <v-spacer></v-spacer>
            <v-tooltip bottom>
              <template v-slot:activator="{ on}">
                <v-btn v-on="on" class @click="reinitialize" text icon color="blue">
                  <v-icon>mdi-refresh</v-icon>
                </v-btn>
              </template>
              <span>Actualizar Tabla</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn v-on="on" class @click="exportExcel" text icon color="green">
                  <v-icon>fas fa-file-excel</v-icon>
                </v-btn>
              </template>
              <span>Exportar Excel</span>
            </v-tooltip>
          </v-card-title>
          <div ref="uniqueName" v-if="loadTransition" class="alert bluesky-line m-0 mb-0"></div>
          <v-card-text>
            <v-data-table
              :headers="headers"
              :items="listado"
              :page.sync="page"
              :items-per-page="itemsPerPage"
              :search="search"
              sort-by="id"
              class="elevation-1 datatable"
            >
              <template v-slot:top>
                <v-card class="mt-1">
                  <v-spacer></v-spacer>
                <v-toolbar flat color="white">
                  <div class="kt-input-icon kt-input-icon--left">
                    <input
                      v-model="search"
                      append-icon="search"
                      label="Búsqueda"
                      type="text"
                      class="form-control form-control-md col-md-8"
                      placeholder="Buscar..."
                    />
                    <span class="kt-input-icon__icon">
                      <span>
                        <i class="la la-search"></i>
                      </span>
                    </span>
                  </div>
                  <!--<div class="form-group row">
                      <div class="col-sm-12"></div>
                    </div>
                  <v-text-field
                    class="text-xs-center mx-2 my-2 form-control searchwarehouse"
                  ></v-text-field>-->

                  <v-spacer></v-spacer>
                  <v-divider class="mx-4" inset vertical></v-divider>
                  <v-dialog v-model="dialog" max-width="600px">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn  dark class="mb-2 btn-starkoms-primary" v-bind="attrs" v-on="on">
                        <i class="fa fa-plus pr-1"></i> Agregar bodega
                      </v-btn>
                    </template>
                    <v-card>
                      <v-card-title>
                        <span class="headline">{{ formTitle }}</span>
                      </v-card-title>

                      <v-card-text>
                        <v-container>
                          <v-form ref="form" v-model="valid" lazy-validation>
                            <v-row>
                              <v-col cols="12" sm="6" md="2" v-if="editedItem.id">
                                <v-text-field
                                  v-model="editedItem.id"
                                  name="id"
                                  label="ID"
                                  readonly="readonly"
                                  prepend-icon="vpn_key"
                                ></v-text-field>
                              </v-col>
                              <v-col cols="12" sm="12" md="12">
                                <v-text-field
                                  v-model="editedItem.name"
                                  :rules="[v => !!v || 'El nombre de la Bodega es requerido!']"
                                  label="Nombre"
                                  prepend-icon="foundation"
                                ></v-text-field>
                              </v-col>
                            </v-row>
                          </v-form>
                        </v-container>
                      </v-card-text>

                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="#FA8072" text @click="close">Cancelar</v-btn>
                        <v-btn color="#00FF00" text @click="save">Guardar</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </v-toolbar>
                </v-card>
              </template>
              <template v-slot:item.actions="{ item }">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on}">
                    <router-link :to="`/inventario/warehouse/${item.id}`">
                      <v-icon v-on="on" color="#93a2dd" small>mdi-eye</v-icon>
                    </router-link>
                    <!-- <v-chip color="#93a2dd" class="ma-2" small dark></v-chip> -->
                  </template>
                  <span>Ver Bodega {{item.id}}</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on}">
                    <v-icon
                      small
                      v-on="on"
                      color="#93a2dd"
                      class="mx-3"
                      @click="editItem(item)"
                    >mdi-pencil</v-icon>
                  </template>
                  <span>Editar Bodega {{item.id}}</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on}">
                    <v-icon v-on="on" small color="#93a2dd" @click="deleteItem(item)">mdi-delete</v-icon>
                  </template>
                  <span>Eliminar Bodega {{item.id}}</span>
                </v-tooltip>
              </template>
              <template v-slot:no-data>
                <v-btn color="#87CEFA" :loading="loading" @click="reinitialize()">Cargando ..</v-btn>
              </template>
            </v-data-table>
            <div class="text-center pt-2">
              <v-pagination v-model="page" :length="pageCount" :total-visible="10"></v-pagination>
            </div>
          </v-card-text>
        </v-card>
      </div>
    </div>
  </v-app>
</template>

<script>
import { SET_BREADCRUMB } from "@/store/breadcrumbs.module";

export default {
  data: () => ({
    page: 1,
    pageCount: 0,
    itemsPerPage: 10,
    dialog: false,
    valid: true,
    loading: false,
    url: "",
    boolean: false,
    loadTransition: false,
    search: "",
    dateMsg:
      new Date().toISOString().substr(0, 10) +
      " " +
      new Date().toISOString().substr(11, 5),
    headers: [
      {
        text: "ID",
        align: "start",
        sortable: false,
        value: "id",
      },
      { text: "Nombre", value: "name" },
      { text: "Acciones", value: "actions", sortable: false },
    ],
    listado: [],
    editedIndex: -1,
    editedItem: {
      id: "",
      name: "",
    },
    defaultItem: {
      id: "",
      name: "",
    },
  }),
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Bodegas", route: "/inventario/warehouse" },
    ]);

    this.loading = true;
    this.fetchWarehouses();


  },
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "Nueva Bodega" : "Editar Bodega";
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
  },

  created() {
    this.initialize();
   // console.log(window);
    //console.log(this.$el.querySelector(".bluesky-line"));
    console.log(this.$refs);
    console.log(this.$store.getters);
    console.log(this.$store.state);
    //console.log(store);
  },

  methods: {
    initialize() {
      if (localStorage.getItem("deleteWarehouse") !== null) {
        //console.log(localStorage.getItem("deleteWarehouse"));
        this.deletedWarehouseMessage();
      }
    },

    editItem(item) {
      this.editedIndex = this.listado.indexOf(item);
      this.editedItem = Object.assign({}, item);

      this.dialog = true;
    },

    deleteItem(item) {
      var vm = this;
      let deleteWarehouse = Object.assign({}, item);

      console.log(deleteWarehouse.id);

      const confirmacion = confirm(
        `Esta seguro de eliminar la Bodega: ${deleteWarehouse.name} || ID: ${deleteWarehouse.id}?`
      );
      if (confirmacion) {
        vm.axios({
          url: "inventory/warehouse/" + deleteWarehouse.id,
          method: "DELETE",
        })
          .then((response) => {
            vm.fetchWarehouses();

            vm.$bvToast.toast(
              `La ${deleteWarehouse.name}, ha sido eliminada, el ${vm.dateMsg} exitosamente!`,
              {
                title: `Información`,
                variant: "success",
                solid: true,
                toaster: "b-toaster-bottom-center",
              }
            );
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    save() {
      var vm = this;

      if (this.editedIndex > -1) {
        //Object.assign(this.listado[this.editedIndex], this.editedItem);

        let editWarehouse = Object.assign({}, this.editedItem);

        if (!vm.editedItem.name.length || vm.editedItem.name == null) {
          vm.$bvToast.toast("El nombre de la Bodega no debe ir vacío!", {
            title: `Formulario Invalido`,
            variant: "danger",
            solid: true,
            toaster: "b-toaster-bottom-center",
          });
          vm.$refs.form.$el[1].focus();
          return;
        }
        if (this.$refs.form.validate()) {
          vm.loadTransition = true;

          //vm.loadTransition.focus();

          this.axios({
            url: "inventory/warehouse/" + vm.editedItem.id,
            method: "PUT",
            data: {
              name: vm.editedItem.name,
            },
          })
            .then((response) => {
              vm.fetchWarehouses();

              vm.$bvToast.toast(
                `La Bodega: ${editWarehouse.name}, ha sido Actualizada el ${vm.dateMsg} exitosamente!`,
                {
                  title: `Información`,
                  variant: "success",
                  solid: true,
                  toaster: "b-toaster-bottom-center",
                }
              );

              vm.loadTransition = false;
            })
            .catch((error) => {
              console.log(error);
            });
        }
      } else {
        let createWarehouse = Object.assign({}, this.editedItem);

        if (!vm.editedItem.name.length || vm.editedItem.name == null) {
          vm.$bvToast.toast("El nombre de la Bodega no debe ir vacío!", {
            title: `Formulario Invalido`,
            variant: "danger",
            solid: true,
            toaster: "b-toaster-bottom-center",
          });
          vm.$refs.form.$el[0].focus();
          return;
        }

        if (this.$refs.form.validate()) {
          this.axios({
            url: "inventory/warehouse",
            method: "POST",
            data: {
              name: vm.editedItem.name,
            },
          })
            .then((response) => {
              vm.fetchWarehouses();
              vm.$bvToast.toast(
                `La Bodega: ${createWarehouse.name}, ha sido creada el ${vm.dateMsg} exitosamente!`,
                {
                  title: `Información`,
                  variant: "success",
                  solid: true,
                  toaster: "b-toaster-bottom-center",
                }
              );
            })
            .catch((error) => {
              console.log(error);
            });
        }
      }
      this.close();
    },
    fetchWarehouses() {
      var vm = this;
      this.axios({
        url: "inventory/warehouse/by_store",
        method: "GET",
      })
        .then((response) => {
          this.loading = false;
          vm.pageCount = Math.ceil(response.data.data.length / 10);
          vm.listado = response.data.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    deletedWarehouseMessage() {
      let deletedWarehouse = JSON.parse(
        localStorage.getItem("deleteWarehouse")
      );

      this.$bvToast.toast(
        `La ${deletedWarehouse.name} ha sido eliminada, el ${this.dateMsg} exitosamente!`,
        {
          title: `Información`,
          variant: "success",
          solid: true,
          toaster: "b-toaster-bottom-center",
        }
      );

      localStorage.removeItem("deleteWarehouse");
    },
    exportExcel() {
      var vm = this;
      let headers = vm.headers.map((e) => e.text);
      let datos = vm.listado;
      this.axios({
        url: "excel/from_array",
        method: "POST",
        data: {
          data: datos,
          cabeceras: headers,
        },
        responseType: "blob",
      })
        .then((response) => {
          const newBlob = new Blob([response.data], {
            type:
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;",
          });
          const data = window.URL.createObjectURL(newBlob);
          window.open(data, "_blank");
        })
        .catch((error) => {
          console.log(error);
        });
    },
    reinitialize() {
      this.listado = [];
      this.loading = true;
      this.fetchWarehouses();
    },
  },
};
</script>